import * as ActionTypes from '../constants';
import { baseUrl } from '.';
import axios from 'axios';
import { getUserToken } from './getUserToken';

const dispatchRequestTestTermsAndConditions = () => ({
    type: ActionTypes.REQUEST_TEST_TERMS_AND_CONDITIONS
})

const dispatchReceivedTestTermsAndConditions = res => ({
    type: ActionTypes.RECEIVED_TEST_TERMS_AND_CONDITIONS,
    res
})

const dispatchErrorTestTermsAndConditions = err => ({
    type: ActionTypes.ERROR_TEST_TERMS_AND_CONDITIONS,
    err
})

const dispatchClearTestTermsAndConditions = () => ({
    type: ActionTypes.CLEAR_TEST_TERMS_AND_CONDITIONS
})

export const clearTestTermsAndConditionsData = () => dispatchClearTestTermsAndConditions();


export const getTestTermsAndConditions = (testId, isPlannedTest, isTestSeries) => dispatch => { 

    const url = isPlannedTest ? 'attempt_planned_test' : isTestSeries ? 'attempt_mock_test' : 'attempt_test';
    const data = isTestSeries ? { mock_test_id : testId} : {test_id: testId }

    getUserToken()
        .then(token => {
            dispatch(dispatchRequestTestTermsAndConditions());   
            const options = {
                method: 'post',
                url: `${baseUrl}/api/${url}`, 
                data,     
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedTestTermsAndConditions(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorTestTermsAndConditions(e.response)));
}
